import { memo } from 'react';

import Main from './components/Main';
import { CalendarServiceOptionsProvider, CalendarServiceProvider } from './store';
import type { CalendarServiceOptions } from './store/types';

const CalendarService = ({ options }: { options: CalendarServiceOptions }) => (
  <CalendarServiceOptionsProvider options={options}>
    <CalendarServiceProvider>
      <Main />
    </CalendarServiceProvider>
  </CalendarServiceOptionsProvider>
);

export default memo(CalendarService);
